import * as App from "@timesheets/routes-app";

import { IApi } from "@timesheets/webapp-support";
import Router from "vue-router";
import { WebApplicationConstants } from "../setup/WebApplicationConstants";

export async function logout(api: IApi, router?: Router, redirectToLogin = true) {
  try {
    await api.logout();
  } catch (innerError) {
    WebApplicationConstants.defaultLogger.warn("Logout failed");
  }

  if (redirectToLogin !== false) {
    if (router) {
      router.push(App.Login.Root).catch(() => {});
    } else {
      window.location.replace(App.Login.Root);
    }
  }
}
